import React from 'react';
import { Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import { PDF_THEMES, DEFAULT_THEME } from '../themes';
import PdfHeader from '../components/PdfHeader';
import PdfFooter from '../components/PdfFooter';
import { PdfTableHead, PdfTableRow, PdfTableFoot } from '../components/PdfTable';
import { fmtINR } from '../pdfUtils';

const s = StyleSheet.create({
  page:       { fontFamily: 'NotoSans', paddingBottom: 60 },
  content:    { marginHorizontal: 40, marginTop: 12 },
  groupLabel: { fontSize: 9, fontWeight: 'bold', paddingVertical: 5, paddingHorizontal: 4 },
});

const COLS = [
  { label: 'Member / Person', flex: 2.5 },
  { label: 'Offered',         flex: 1.2, align: 'right' },
  { label: 'Paid',            flex: 1.2, align: 'right' },
  { label: 'Pending',         flex: 1.2, align: 'right' },
];

export default function FamilyReportDocument({ data, theme: themeKey, orientation, sections }) {
  const t = PDF_THEMES[themeKey] || PDF_THEMES[DEFAULT_THEME];
  const groups = Array.isArray(data.familyGroups) ? data.familyGroups : [];

  return (
    <Document>
      <Page size="A4" orientation={orientation || 'portrait'} style={[s.page, { backgroundColor: t.white }]}>
        {sections.header && <PdfHeader derasar={data.derasar} reportTitle="Family Report" theme={t} />}
        <View style={s.content}>
          <PdfTableHead cols={COLS} theme={t} />
          {groups.map((group, gi) => (
            <React.Fragment key={gi}>
              <View style={[s.groupLabel, { backgroundColor: t.light }]}>
                <Text style={{ color: t.body, fontSize: 9, fontWeight: 'bold' }}>
                  {group.label} — {fmtINR(group.pledged)} offered / {fmtINR(group.paid)} paid
                </Text>
              </View>
              {(group.members || []).map((m, mi) => (
                <PdfTableRow key={`m${mi}`} cols={COLS} index={mi} theme={t}
                  values={[m.name || '—', fmtINR(m.pledged), fmtINR(m.paid), fmtINR(m.pending)]}
                />
              ))}
            </React.Fragment>
          ))}
          <PdfTableFoot cols={COLS}
            values={[
              'Grand Total',
              fmtINR(groups.reduce((s, g) => s + Number(g.pledged || 0), 0)),
              fmtINR(groups.reduce((s, g) => s + Number(g.paid    || 0), 0)),
              fmtINR(groups.reduce((s, g) => s + Number(g.pending || 0), 0)),
            ]}
            theme={t}
          />
        </View>
        {sections.footer && <PdfFooter theme={t} />}
      </Page>
    </Document>
  );
}


